import {VersionType} from "../enums/versionType";
import StringHelpers from "../helpers/stringHelpers";

export default {
  mixins: [StringHelpers],
  props: {
    version: Object,
    versionType: {
      type: Number as () => VersionType,
      default: null
    },
    versionTypeName: {
      type: String
    },
    versionStoreKey: {
      type: String
    }
  },
  data: function() {
    return {
      VersionType: VersionType,
    };
  },
  computed: {
    versionTypeKey(): string {
      return VersionType[this.versionType || this.version.versionType];
    },
    versionTypeNameOrKey(): string {
      return this.versionTypeName || this.version.versionTypeName || this.versionTypeKey;
    },
    capitalizedVersionTypeName(): string {
      return this.$options.filters.capitalize(this.versionTypeNameOrKey);
    },
    versionKey(): string {
      return `${this.versionTypeNameOrKey}s`;
    },
    versionIdKey(): string {
      return `${this.versionTypeNameOrKey}_ids`;
    },
    versionStore(): string {
      return this.versionStoreKey || `${this.versionTypeKey}Store`;
    },
    versionPreviewStore() {
      return `preview${this.capitalizedVersionTypeName}Store`;
    }
  },
  methods: {
    versionTypeIs(type: VersionType): boolean {
      return this.versionType === type;
    }
  }
};